/* Claude 4.08 — auto-pagination for EVERY collection, plus a loading spinner
   and an end-of-list marker.

   SPLIT OUT OF assets/claude-posters.js IN 4.08. The auto-scroll layer was
   written in 3.84 as part of the poster feature and shipped inside
   claude-posters.js, which is loaded by snippets/claude-posters.liquid — and
   that snippet is rendered from a custom-liquid section in exactly two
   templates (collection.black-friday-sale.json and collection.cowhide-rugs.json).
   So 29 of the store's 31 collections had the View-more button and none of the
   auto-load, purely because they carry no posters. Nothing about watching a
   sentinel and clicking a button has anything to do with posters; this file is
   that layer, loaded from the grid section itself so it runs everywhere.

   IT STILL DOES NOT FETCH ANYTHING. Everything here is layered on top of the
   existing View-more loader inline in
   sections/main-collection-product-grid-viewmore.liquid (and its byte-identical
   twin snippets/cb-view-more.liquid), which already handles fetching,
   appending, dedupe, prefetch, error/retry and sessionStorage restore. We watch
   its public DOM signals and synthesise a click on its button. If this file
   ever dies, the button is still there and still works — which is why the
   wrapper is COLLAPSED with a class rather than removed.

   4.08 — SKELETONS ARE GONE. 3.84 appended eight `<li class="cpo-sk">`
   placeholders before each batch. The owner chose a spinner instead (option B),
   so showSkeletons/clearSkeletons and all .cpo-sk markup are removed here.
   The .cpo-sk* CSS is deliberately LEFT IN PLACE in assets/claude-posters.css —
   including the 4.05 `.cpo-sk__ph:empty { display: block }` fix for Dawn's
   `div:empty { display: none }` rule — but with nothing creating the markup any
   more, that fix is now DORMANT on collection pages. Do not delete it while
   the class names still exist; do not assume it is being exercised either.

   The same `div:empty` trap is live in THIS file: .cble__rule is an empty div,
   so assets/claude-autoload.css carries its own `:empty` guard. That is the
   fourth time this theme has been bitten (loader skeletons 4.05, BF hero scrim
   4.06, poster label rule 4.07). Any decorative empty div needs one.
*/
(function () {
  if (window.cbAutoloadInit) return;
  window.cbAutoloadInit = true;

  /* 4.21: RESCUE A DEAD ?page=N BEFORE ANYTHING ELSE.
     Until 4.21 the loader rewrote the address bar to ?page=N as the shopper
     scrolled, so those URLs are now sitting in browser histories, bookmarks,
     shared links and search-engine indexes. These are one-of-a-kind hides: the
     collection shrinks as they sell, and a ?page=5 that was valid last week
     renders an EMPTY collection today -- no cards, no button, no counter, no
     way onward (Shopify serves an out-of-range page rather than a 404).
     So: if the URL carries a page param and the grid rendered no product cards
     at all, send the shopper to the clean collection URL. location.replace, not
     assign, so the dead page does not become another back-button trap.
     Deliberately BEFORE the #product-grid guard and before any other work, and
     deliberately narrow -- a page that rendered even one card is a legitimate
     deep link and 3.88's offset counter handles it. */
  (function rescueEmptyPage() {
    try {
      if (!/[?&]page=[0-9]+/.test(location.search)) return;
      if (document.querySelectorAll('#product-grid > .grid__item').length) return;
      var u = new URL(location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      location.replace(u.pathname + (u.search || ''));
    } catch (e) {}
  })();

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  /* READ ONCE, AT INIT. The wrapper carries data-cb-total and data-cb-offset,
     and the loader REMOVES the whole wrapper on the final batch — so anything
     that needs those numbers after the collection is exhausted has to have
     cached them before. */
  var wrapper0 = document.querySelector('.cb-view-more-wrapper');
  var HAD_WRAPPER = !!wrapper0;
  var TOTAL = wrapper0 ? parseInt(wrapper0.getAttribute('data-cb-total'), 10) || 0 : 0;
  /* 3.88: how far into the collection this page starts. 0 on page 1. On a
     deep-linked ?page=3 the grid holds items 141-199, so without this the
     counters would measure 59 products against a total they cannot see. */
  var OFFSET = wrapper0 ? parseInt(wrapper0.getAttribute('data-cb-offset'), 10) || 0 : 0;

  /* 4.08: the end-of-list copy has to be generic now that this runs on 31
     collections, so every string is overridable from Liquid via data attributes
     on the wrapper. `{count}` is substituted in data-cbl-end if present. */
  function attr(name) {
    var v = wrapper0 ? wrapper0.getAttribute(name) : null;
    return v == null ? '' : v;
  }
  /* 4.08: SEARCH RESULTS ARE NOT "PIECES IN THIS COLLECTION".
     sections/main-search.liquid now renders the same loader, so this file runs
     there too and the collection copy read wrong on /search.

     DETECTION IS CLASS-BASED, NOT PATH-BASED, but NOT from <body>: this store's
     body is class="gradient animate--hover-default" -- Dawn ships no template
     class on it. The body check below is kept anyway because it costs nothing
     and is the right signal the day one is added. The signal that actually
     fires is the markup main-search.liquid emits: a .template-search wrapper,
     with #product-grid itself carrying .template-search__results. That is a
     direct read of the section doing the rendering, which is sturdier than a
     URL. location.pathname is the last resort only. */
  var IS_SEARCH = (function () {
    var b = document.body;
    if (b && b.classList && b.classList.contains('template-search')) return true;
    if (grid.classList.contains('template-search__results')) return true;
    if (grid.closest && grid.closest('.template-search')) return true;
    return location.pathname.indexOf('/search') === 0;
  })();

  var NOUN = attr('data-cbl-noun') || (IS_SEARCH ? 'results' : 'pieces');
  var END_TITLE = attr('data-cbl-end');
  var END_SUB = attr('data-cbl-endsub') ||
    (IS_SEARCH
      ? 'That’s everything matching your search.'
      : 'You’ve seen everything in this collection.');

  function productCount() {
    return grid.querySelectorAll(':scope > .grid__item').length;
  }
  function loadBtn() { return document.querySelector('[data-cb-load-more]'); }
  function wrap() { return document.querySelector('.cb-view-more-wrapper'); }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function toTop() {
    /* 4.05: smooth scroll was unconditional; honour the OS setting. */
    window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  /* ---------------- loading spinner (4.08, option B) ----------------

     Inserted ONCE, immediately after the grid <ul>, so it sits between the last
     row of cards and the View-more wrapper — where the eye already is when a
     batch is coming.

     There is NO loading class anywhere in the loader: the only in-flight signal
     it publishes is on the BUTTON, where loadNext() sets data-cb-loading="1"
     and aria-busy="true" together, and appendDoc()/fail() clear them again. So
     that is what we watch.

     aria-hidden stays "true" for the whole life of the element on purpose. The
     loader already owns an aria-live region ([data-cb-announce]) that says
     "N more products loaded — showing X of Y"; a second live announcement of
     "Loading more…" would just talk over it. The spinner is decoration. */
  var spinner = document.createElement('div');
  spinner.className = 'cbl';
  spinner.setAttribute('data-cbl', '');
  spinner.hidden = true;
  spinner.setAttribute('aria-hidden', 'true');
  spinner.innerHTML = '<span class="cbl__ring"></span><span class="cbl__t">Loading more…</span>';
  if (grid.parentNode) grid.parentNode.insertBefore(spinner, grid.nextSibling);

  /* SUPPRESSED DURING THE sessionStorage RESTORE REPLAY. The loader's own
     `restoring` flag is a closure variable with no public surface, so it cannot
     be read directly — but the thing that DRIVES it can be: the loader stores
     {p: pagesLoaded, y: scrollY, t: timestamp} under a key it builds from the
     path and the query with any page param stripped. We rebuild that key with
     the identical expression and read how many batches are about to be
     replayed, so the shopper coming back from a product does not watch the
     spinner flash five times for a restore they did not ask for.

     THIS MIRRORS THE LOADER'S `KEY` EXPRESSION — if that ever changes, change
     it here too. It fails safe: an unreadable or stale entry simply means no
     suppression, and the counter is dropped after 15s regardless so a restore
     that stalls cannot wedge the spinner off for the rest of the visit. */
  var replayLeft = 0;
  var replayUntil = 0;
  (function readRestore() {
    var raw;
    try {
      raw = sessionStorage.getItem(
        'cbVM:' + location.pathname + ':' + location.search.replace(/[?&]page=[0-9]+/g, '')
      );
    } catch (e) { return; }
    if (!raw) return;
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st || !st.p) return;
    if (Date.now() - (st.t || 0) > 1800000) return; /* the loader's own 30-min expiry */
    replayLeft = st.p;
    replayUntil = Date.now() + 15000;
  })();

  var spinnerOn = false;
  function syncSpinner() {
    var b = loadBtn();
    var busyNow = !!b && (b.dataset.cbLoading === '1' || b.getAttribute('aria-busy') === 'true');
    /* On a hard failure the loader turns the button itself into "Couldn't load
       more — tap to retry". Showing a spinner beside its own retry UI would say
       two different things at once, so we stand down and let it speak. */
    if (b && b.dataset.cbError === '1') busyNow = false;
    if (replayLeft > 0 && Date.now() < replayUntil) busyNow = false;
    if (busyNow === spinnerOn) return;
    spinnerOn = busyNow;
    spinner.hidden = !busyNow;
  }

  /* ---------------- end-of-list marker (4.08, option B) ----------------

     The loader's "no more pages" signal is the removal of .cb-view-more-wrapper
     — appendDoc() calls w.remove() exactly when the fetched section carried no
     next button, or the remaining count fell to zero. That removal is the
     trigger.

     TWO DELIBERATE DEPARTURES FROM A NAIVE `offset + shown >= total` TEST:

     1. It is checked as `OFFSET === 0` rather than included in the arithmetic.
        A shopper who deep-linked to ?page=3 and then loaded page 4 HAS reached
        the end of the list, but has NOT "seen everything in this collection" —
        saying so would be a lie, and the loader already renders its own
        "Showing part of this collection — start from the beginning" notice for
        exactly that case. So the marker is only offered to shoppers who started
        at the top.
     2. `shown >= total` is NOT required. The 3.88 dedupe drops cards that the
        Sortd merchandiser moved between two fetches (4 products in a single
        measured audit), so an exhausted collection can legitimately finish a
        few short of paginate.items. Requiring the arithmetic to balance would
        silently suppress the marker on precisely the collections the dedupe
        exists for. The wrapper's removal is the loader's own verdict; we take
        it. The arithmetic is used for the DISPLAYED count only. */
  var endDone = false;
  function maybeEnd() {
    if (endDone) return;
    if (!HAD_WRAPPER || OFFSET !== 0) return;
    if (wrap()) return;
    var shown = productCount();
    if (!shown) return;
    endDone = true;

    /* On a collection Math.max(TOTAL, shown) is right: the 3.88 dedupe can
       legitimately trim a card or two and paginate.items is the honest
       catalogue number. On search it is wrong -- it printed "271" against 270
       rendered cards, a number the shopper cannot find on the page. Search
       counts what is actually on screen. */
    var count = IS_SEARCH ? shown : Math.max(TOTAL, shown);
    var title = END_TITLE
      ? END_TITLE.split('{count}').join(String(count)).split('{noun}').join(NOUN)
      : 'That’s all ' + count + ' ' + NOUN + '.';

    var el = document.createElement('div');
    el.className = 'cble';
    el.setAttribute('role', 'status');
    var rule = document.createElement('div');
    rule.className = 'cble__rule';
    var t = document.createElement('p');
    t.className = 'cble__t';
    t.textContent = title;
    var s = document.createElement('p');
    s.className = 'cble__s';
    s.textContent = END_SUB;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cble__top';
    b.textContent = 'Back to top';
    b.addEventListener('click', toTop);
    el.appendChild(rule);
    el.appendChild(t);
    el.appendChild(s);
    el.appendChild(b);
    /* after the spinner, which sits directly after the grid */
    if (spinner.parentNode) spinner.parentNode.insertBefore(el, spinner.nextSibling);
  }

  /* ---------------- progress pill ----------------
     Markup comes from snippets/claude-posters.liquid, which is only rendered on
     the two poster templates, so this is a no-op everywhere else. Kept here
     rather than left behind because it counts the same cards against the same
     data-cb-total this file already reads. */
  var pill = document.querySelector('[data-cpg]');
  function updatePill() {
    if (!pill) return;
    var shown = OFFSET + productCount();
    var total = TOTAL || shown;
    var num = pill.querySelector('.cpg__num');
    var fill = pill.querySelector('.cpg__fill');
    if (num) num.textContent = shown + ' of ' + total;
    if (fill) fill.style.width = Math.min(100, (shown / total) * 100) + '%';
    pill.classList.add('is-visible');
  }
  if (pill) {
    var topBtn = pill.querySelector('.cpg__top');
    if (topBtn) topBtn.addEventListener('click', toTop);
  }

  /* ---------------- auto-load ---------------- */

  /* `pending` is our own guard, deliberately not relying solely on the existing
     loader's aria-busy flag. If that loader ever stalls without clearing its
     flag — or a future edit stops setting it — a scroll listener plus a timer
     would otherwise fire click() dozens of times per second. It clears when the
     grid actually grows, or after a 15s safety timeout so a genuinely failed
     fetch doesn't wedge pagination shut for the rest of the session. */
  var pending = false;
  var pendingAt = 0;
  var countAtRequest = 0;

  /* 4.05 introduced a checkpoint: two batches would load themselves, then the
     wrapper uncollapsed and the shopper had to tap "View N more" to buy two
     more. 4.21 REMOVES IT -- owner's call, 25 Aug 2026, after reporting the
     collection "stops and won't go further" at 120 of 160. Scrolling now runs
     to the end of the collection.
     The budget machinery is deliberately left standing rather than ripped out:
     every `autoBudget` branch below still evaluates, it simply never runs out,
     and putting a finite number back here is the whole of the rollback. */
  var AUTO_BATCHES = Infinity;
  var autoBudget = AUTO_BATCHES;
  /* True only for the instant we synthesise a click on the loader's button, so
     the listener below can tell our own auto-load from a human tap. click() is
     dispatched synchronously, so the flag is reliably set while it runs. */
  var selfClick = false;

  function busy() {
    var b = loadBtn();
    if (!b) return true;
    if (pending) {
      if (productCount() > countAtRequest) { pending = false; }
      else if (Date.now() - pendingAt > 15000) { pending = false; }
      else return true;
    }
    return b.getAttribute('aria-busy') === 'true' || b.dataset.cbLoading === '1';
  }

  /* 4.05: THE SENTINEL IS THE LAST PRODUCT CARD, NOT THE WRAPPER.
     The wrapper is the obvious target and a poor one. It is collapsed to
     height:0 by .cpo-autoload while auto-loading, so it is a zero-area box, and
     it is the SAME element on every batch -- the exact shape that made a plain
     IntersectionObserver stall in 3.84 and pushed that author onto a 700ms
     ticker.
     The last card avoids both problems by construction: it is always a real
     sized box, and it is a DIFFERENT element after every append, so pointing the
     observer at it IS the re-arm. No unobserve/observe dance to get wrong, and
     no dependence on how a given browser treats an empty rect.
     Verified in a local Playwright harness driving this exact file: two batches
     auto-load, the checkpoint appears, a tap resumes, and the run reaches the
     end of a 186-product collection. (Do not try to verify this through a
     background tab -- Chrome suspends IntersectionObserver and rAF there, which
     looks identical to the code being broken.) */
  var io = null;
  var observed = null;
  function sentinel() {
    var kids = grid.querySelectorAll(':scope > .grid__item');
    return kids.length ? kids[kids.length - 1] : null;
  }
  function armObserver() {
    if (!('IntersectionObserver' in window)) return;
    var s = sentinel();
    if (!s || s === observed) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { maybeLoad(); return; }
        }
      }, { rootMargin: '700px' });
    }
    if (observed) io.unobserve(observed);
    io.observe(s);
    observed = s;
  }
  function disarmObserver() { if (io) { io.disconnect(); } observed = null; }

  function maybeLoad() {
    var w = wrap();
    if (!w) {                          // everything loaded; the loader removes it
      disarmObserver();
      maybeEnd();
      return;
    }
    /* 3.88: since the wrapper now also renders on the LAST page (where it
       carries the counter and the back-to-page-1 link but no button), stop
       here instead of watching a button that will never exist. */
    if (!loadBtn()) {
      disarmObserver();
      return;
    }
    /* 3.88: THE RETRY BUTTON HAS TO BE VISIBLE TO BE TAPPABLE.
       Caught by looking at a render, not by reasoning: when a fetch fails the
       loader now puts the button into a "tap to retry" state instead of
       navigating -- but on this page the whole wrapper is collapsed to zero
       height by .cpo-autoload, so that button was being offered to nobody. On
       error, uncollapse it (which also reveals the honest "Showing 70 of 199"
       counter) and STOP auto-clicking: from here it is the shopper's call.
       Tapping clears data-cb-error, so the next tick re-collapses and normal
       auto-load resumes. */
    var eb = loadBtn();
    if (eb.dataset.cbError === '1') {
      w.classList.remove('cpo-autoload');
      disarmObserver();
      return;
    }
    /* 4.05's checkpoint: budget spent -> uncollapse the wrapper and stop. With
       AUTO_BATCHES at Infinity (4.21) this branch never fires; it is kept so
       that restoring a finite budget is a one-line change. */
    if (autoBudget <= 0) {
      w.classList.remove('cpo-autoload');
      disarmObserver();
      return;
    }
    if (!w.classList.contains('cpo-autoload')) w.classList.add('cpo-autoload');
    if (busy()) return;
    var r = w.getBoundingClientRect();
    if (r.top > window.innerHeight + 700) return;
    autoBudget -= 1;
    pending = true;
    pendingAt = Date.now();
    countAtRequest = productCount();
    var b = loadBtn();
    if (b) {
      selfClick = true;
      b.click();                       // reuse the existing loader wholesale
      selfClick = false;
    }
    syncSpinner();
  }

  /* A real tap on the button -- now only ever the 3.88 retry state, since 4.21
     removed the checkpoint -- refills the budget and puts the collapse back. */
  document.addEventListener('click', function (e) {
    if (selfClick) return;
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-cb-load-more]')) return;
    autoBudget = AUTO_BATCHES;
    /* a deliberate tap is never part of a restore replay */
    replayLeft = 0;
    var w = wrap();
    if (w) w.classList.add('cpo-autoload');
    armObserver();
  });

  // Refresh the pill and re-arm whenever the grid changes.
  var mo = new MutationObserver(function () {
    clearTimeout(mo._t);
    mo._t = setTimeout(function () {
      if (replayLeft > 0) replayLeft -= 1;
      updatePill();
      syncSpinner();
      /* 4.05: the grid grew, so the last card -- the sentinel -- is a new
         element. Re-point the observer at it. armObserver() is a no-op when the
         card has not changed, so this is safe to call on every mutation. */
      if (autoBudget > 0) armObserver();
      maybeEnd();
    }, 60);
  });
  mo.observe(grid, { childList: true });

  /* Two narrow observers rather than one wide one:
     - attrMo watches the wrapper subtree for the button's in-flight attributes.
     - hostMo watches the wrapper's PARENT for childList only, WITHOUT subtree,
       so card appends (which happen inside the <ul>) do not wake it. Its job is
       to notice the wrapper being removed on the final batch, which is also the
       moment attrMo goes quiet because its target is detached. */
  if (wrapper0) {
    var attrMo = new MutationObserver(syncSpinner);
    attrMo.observe(wrapper0, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-busy', 'data-cb-loading', 'data-cb-error']
    });
    if (wrapper0.parentNode) {
      var hostMo = new MutationObserver(function () {
        syncSpinner();
        maybeEnd();
      });
      hostMo.observe(wrapper0.parentNode, { childList: true });
    }
  }

  /* 3.88: .cpo-autoload collapses the wrapper to zero height, which is right
     while we are auto-clicking its button but WRONG on the last page, where
     the wrapper is now the only thing telling a deep-linked shopper where they
     are and offering them the way back. Only collapse it if there is actually
     a button to hide. */
  if (wrapper0 && loadBtn()) wrapper0.classList.add('cpo-autoload');

  /* 4.05: the 700ms setInterval is gone. What remains is one time-throttled
     check that runs at most every 120ms and ONLY while a finger is actually
     moving -- nothing at all when the shopper is still, which is the whole
     point. It is the fallback for browsers without IntersectionObserver and a
     second pair of eyes on the sentinel.
     Deliberately a timestamp and not a requestAnimationFrame latch: a latch
     that is set before the frame and cleared inside it wedges shut forever if
     that frame never runs (background tab, thrown callback), and a wedged
     fallback is exactly the failure this release exists to remove. */
  var lastCheck = 0;
  function onScrollEvent() {
    var now = Date.now();
    if (now - lastCheck < 120) return;
    lastCheck = now;
    maybeLoad();
  }
  window.addEventListener('scroll', onScrollEvent, { passive: true });
  window.addEventListener('resize', onScrollEvent, { passive: true });

  updatePill();
  syncSpinner();
  armObserver();
  maybeLoad();
})();
